var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.41667 18.7682C2.95833 18.7682 2.56583 18.6049 2.23917 18.2782C1.91306 17.9521 1.75 17.5599 1.75 17.1016V5.4349C1.75 4.97656 1.91306 4.58406 2.23917 4.2574C2.56583 3.93128 2.95833 3.76823 3.41667 3.76823H10.8542L9.1875 5.4349H3.41667V17.1016H15.0833V11.3099L16.75 9.64323V17.1016C16.75 17.5599 16.5869 17.9521 16.2608 18.2782C15.9342 18.6049 15.5417 18.7682 15.0833 18.7682H3.41667ZM12.7292 4.2474L13.9167 5.41406L8.41667 10.9141V12.1016H9.58333L15.1042 6.58073L16.2917 7.7474L10.7708 13.2682C10.6181 13.421 10.4411 13.5427 10.24 13.6332C10.0383 13.7232 9.82639 13.7682 9.60417 13.7682H7.58333C7.34722 13.7682 7.14944 13.6885 6.99 13.5291C6.83 13.3691 6.75 13.171 6.75 12.9349V10.9141C6.75 10.6918 6.79167 10.4799 6.875 10.2782C6.95833 10.0771 7.07639 9.90017 7.22917 9.7474L12.7292 4.2474ZM16.2917 7.7474L12.7292 4.2474L14.8125 2.16406C15.1458 1.83073 15.5453 1.66406 16.0108 1.66406C16.4758 1.66406 16.8681 1.83073 17.1875 2.16406L18.3542 3.35156C18.6736 3.67101 18.8333 4.0599 18.8333 4.51823C18.8333 4.97656 18.6736 5.36545 18.3542 5.6849L16.2917 7.7474Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/review.d6322bfe759584a9b51f9582d96bfe63.svg";
export { ForwardRef as ReactComponent };